"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOURCE = exports.SCENE = exports.PROGRAM_AREA = exports.OVERLAY_BACKGROUND = exports.BANNER_TYPE = void 0;
var SCENE = exports.SCENE = 'SCENE';
var SOURCE = exports.SOURCE = 'SOURCE';
var BANNER_TYPE = exports.BANNER_TYPE = 'BANNER';
var OVERLAY_BACKGROUND = exports.OVERLAY_BACKGROUND = 'OVERLAY_BACKGROUND';
var PROGRAM_AREA = exports.PROGRAM_AREA = 'PROGRAM_AREA';